/** @jsxImportSource @emotion/react */

import { cn } from '@shared/cove-ui';
import VisiblyHidden from '../VisiblyHidden';

const PrettyPrice: React.FC<{
  price: number;
  variant?: 'base' | 'product-page';
  className?: string;
}> = ({ price = 0, variant = 'base', className = '' }) => {
  const priceDecimals = parseFloat(`${price}`).toFixed(2);
  const priceSplit = priceDecimals.split('.');
  const left = priceSplit[0];
  const right = priceSplit[1];
  const isNegative = +left < 0;
  const productPageVariant = variant === 'product-page';

  return (
    <span
      className={cn(
        'text-[16px] leading-[21px] text-inherit',
        productPageVariant && 'lg:text-lg',
        className
      )}
    >
      <span className="text-inherit" aria-hidden>
        {isNegative && '-'}${Math.abs(+left)}.
        <span
          className={cn(
            'text-[14px] leading-[14px] text-inherit',
            productPageVariant && 'lg:text-lg'
          )}
        >
          {right}
        </span>
      </span>
      <VisiblyHidden>{`$${priceDecimals}`}</VisiblyHidden>
    </span>
  );
};

export default PrettyPrice;
